import styled from '@emotion/styled'
import React from 'react'

interface SectionTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, ...props }) => {
  return (
    <div {...props}>
      <Title>{title}</Title>
    </div>
  )
}

const Title = styled.h3`
  color: #4a4a68;
  line-height: 1;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.2px;
  margin-bottom: 0;
`

export default SectionTitle
